import { Box, styled, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

const RowWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '20px',
  margin: '50px 0',
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: '10px'
  },
  [theme.breakpoints.up('lg')]: {
    padding: '0 70px 0 0',
    gap: '80px'
  },
  [theme.breakpoints.up('xl')]: {
    padding: 0
  }
}))

const EvenRowWrapper = styled(RowWrapper)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row-reverse'
  },
  [theme.breakpoints.up('lg')]: {
    padding: '0 70px 0 0'
  },
  [theme.breakpoints.up('xl')]: {
    padding: 0
  }
}))

const VideoSection = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'relative',
  padding: 0,
  marginBottom: '80px',
  '&:before': {
    content: "''",
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) rotate(-18.491deg)',
    width: '400px',
    height: '400px',
    background: 'linear-gradient(164deg, #D5FFF2 18.73%, #FFF 120.57%)',
    borderRadius: '30px'
  },
  [theme.breakpoints.up('sm')]: {
    padding: '40px 0',
    marginTop: '60px',
    '&:before': {
      width: '500px',
      height: '500px',
      borderRadius: '54px'
    }
  },
  [theme.breakpoints.up('md')]: {
    padding: '80px 0',
    marginBottom: '100px',
    marginTop: '60px',
    '&:before': {
      width: '580px',
      height: '580px',
      borderRadius: '64px'
    }
  },
  [theme.breakpoints.up('lg')]: {
    padding: '80px 0 100px',
    marginBottom: '100px',
    marginTop: '80px',
    '&:before': {
      width: '780px',
      height: '780px',
      borderRadius: '78px'
    }
  },
  [theme.breakpoints.up('xl')]: {
    padding: '100px 0 140px',
    marginBottom: '120px',
    marginTop: 0,
    '&:before': {
      width: '880px',
      height: '880px'
    }
  }
}))

const VideoSizer = styled(Box)(({ theme }) => ({
  margin: '0 auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '600px'
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: '720px'
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: '960px'
  },
  [theme.breakpoints.up('xl')]: {
    maxWidth: '1100px'
  }
}))

const VideoWrapper = styled(Box)(() => ({
  position: 'relative',
  flex: 1,
  diplay: 'block',
  paddingBottom: '56.25%',
  height: 0,
  zIndex: 2,
  '& iframe': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
}))

const VideoTitle = styled(Typography)(({ theme }) => ({
  position: 'relative',
  fontSize: '1.75rem',
  fontWeight: 600,
  lineHeight: 1.25,
  textAlign: 'center',
  marginBottom: '20px',
  background: 'linear-gradient(134.15deg, #202CD3 5%, #02E39F 80%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  textFillColor: 'transparent',
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '3rem'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '4rem'
  }
}))

const VideoMessage = styled(Typography)(({ theme }) => ({
  fontFamily: '"proxima-nova", sans-serif',
  position: 'relative',
  fontSize: '1rem',
  lineHeight: 1.5,
  margin: '20px auto 0',
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '620px'
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: '740px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.375rem',
    maxWidth: '980px',
    margin: '60px auto 0'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.75rem',
    maxWidth: '1150px'
  }
}))

const ImageBlock = styled(Box)(({ theme }) => ({
  width: '100%',
  '& img': {
    width: '100%'
  },
  [theme.breakpoints.up('md')]: {
    width: '53%'
  }
}))

const TextBlock = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    position: 'relative',
    textAlign: 'left',
    width: '47%'
  }
}))

const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.75rem',
  fontWeight: 600,
  lineHeight: 1.25,
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '3rem'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '4rem'
  }
}))

const Message = styled(Typography)(({ theme }) => ({
  fontFamily: '"proxima-nova", sans-serif',
  fontSize: '1rem',
  lineHeight: 1.5,
  margin: '20px 0',
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.375rem'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.75rem'
  }
}))

export default function Blocks() {
  return (
    <Box component="section" sx={{ padding: { xs: '0 10px', md: '0 75px', lg: '0 140px', xl: '0 10px' } }}>
      <VideoSection>
        <VideoTitle>Share together. Be together.</VideoTitle>
        <VideoSizer>
          <VideoWrapper>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/j9DvTWWPhjA?si=nuCYiSJJyYrcb_oX"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </VideoWrapper>
        </VideoSizer>
        <VideoMessage>
          New Group Buckets makes it easier to share your photos and videos with a group of family and friends. Keeping everyone a little closer by
          sharing memories as they happen.
        </VideoMessage>
      </VideoSection>
      <EvenRowWrapper>
        <ImageBlock>
          <img
            src="//content.photobucket.com/img/homepage/blocks-universe.webp"
            loading="lazy"
            alt="A view of the Photobucket app help you keep all your photos in one place."
          />
        </ImageBlock>
        <TextBlock>
          <SubTitle>Roundup all your digital memories.</SubTitle>
          <Message>
            Too many vacation pics here. Awkward family videos there. And random selfies you&apos;d rather not talk about everywhere. Perfectly normal
            and totally unorganized. Like everyone else. Luckily, Photobucket helps you{' '}
            <Link to="https://blog.photobucket.com/the-advantages-of-centralizing-photos-and-videos-on-photobucket" target="_blank">
              consolidate
            </Link>{' '}
            your digital life from all your favorite social platforms into one, easy-to-use app.
          </Message>
        </TextBlock>
      </EvenRowWrapper>

      <RowWrapper>
        <ImageBlock>
          <img
            src="//content.photobucket.com/img/homepage/blocks-comm.webp"
            loading="lazy"
            alt="Polaroid images of a mom with her child eating ice cream and a super cute cat on a bed."
          />
        </ImageBlock>
        <TextBlock>
          <SubTitle>Share your passions.</SubTitle>
          <Message>
            Love cat videos, sharing food pics, or documenting everything your baby does? Photobucket makes it easy to share your favorite moments and
            passions with family and friends, no matter if they&apos;re on iOS or Android. Photobucket&apos;s photo storage and video storage is the
            perfect place for{' '}
            <Link to="https://blog.photobucket.com/new-group-buckets-takes-the-pain-out-of-group-sharing" target="_blank">
              group sharing
            </Link>{' '}
            of any kind.
          </Message>
        </TextBlock>
      </RowWrapper>

      <EvenRowWrapper>
        <ImageBlock>
          <img src="//content.photobucket.com/img/homepage/HP_image.webp" loading="lazy" alt="We value your privacy." />
        </ImageBlock>
        <TextBlock>
          <SubTitle>Embed your photos in a snap.</SubTitle>
          <Message>
            Whether you&apos;re an avid blogger or e-commerce seller, our easy-to-copy embed links make{' '}
            <Link to="https://blog.photobucket.com/image-hosting-how-and-when-to-host-images" target="_blank">
              hosting
            </Link>{' '}
            your images a no-brainer. Forget uploading the same picture to different forums, websites or marketplaces. Photobucket&apos;s{' '}
            <Link to="https://my.photobucket.com/storageplan-ps-pp-0" target="_blank">
              Hosting Plan
            </Link>{' '}
            does all the work, optimizing your images by automatically adjusting their size to the device being used to view them.
          </Message>
        </TextBlock>
      </EvenRowWrapper>

      <RowWrapper>
        <ImageBlock>
          <img src="//content.photobucket.com/img/homepage/blocks-privacy.webp" loading="lazy" alt="We value your privacy." />
        </ImageBlock>
        <TextBlock>
          <SubTitle>Safeguard your memories.</SubTitle>
          <Message>
            Every picture and video you take today is a memory you&apos;ll treasure tomorrow. That&apos;s something we take seriously and what makes
            Photobucket different. Our compression-free backup cloud storage means your pictures and videos won&apos;t lose quality over time. So,
            that video you take of your baby&apos;s first steps today will still be pixel perfect the day she graduates from college. We{' '}
            <Link to="https://blog.photobucket.com/photobucket-guarantees-the-digital-quality-of-your-memories" target="_blank">
              guarantee
            </Link>{' '}
            it!
          </Message>
        </TextBlock>
      </RowWrapper>

      <EvenRowWrapper>
        <ImageBlock>
          <img src="//content.photobucket.com/img/homepage/blocks-planet.webp" loading="lazy" alt="Store your photos at their best quality." />
        </ImageBlock>
        <TextBlock>
          <SubTitle>Help protect our planet too.</SubTitle>
          <Message>
            Since 2003, we&apos;ve been safeguarding memories with backup cloud storage. We&apos;re talking over 70 million customers with over 13
            billion photos and videos from around the world. All perfectly preserved using{' '}
            <Link to="https://blog.photobucket.com/photobucket-has-a-life-long-commitment-to-our-customers-our-planet" target="_blank">
              carbon-neutral memory management.
            </Link>{' '}
            Because we love our planet as much as we love our customers.
          </Message>
        </TextBlock>
      </EvenRowWrapper>
    </Box>
  )
}
